export const GIF_PATH =
    'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/5f517f1e6e08984ac502d04f92856003-1766493023376/L2-FastDelivery%20%282%29.png';
export const SOURCE_COMPONENT = 'recommendation_express_delivery';
export const BASE_KEY = 'search_perseus.recommendations.express_delivery';
export const URL = '/listings/fetch_express_recommendations';
export const BANNER_ROW = 3;
export const FIRST_HIGH_PRICED_GIGS = 3;
export const AMOUNT_OF_SHOWN_GIGS = 4;
export const BANNER_CLASS_NAME = 'express-delivery-banner';
